import { render, staticRenderFns } from "./Badge18.vue?vue&type=template&id=ff84e37a&scoped=true"
import script from "./Badge18.vue?vue&type=script&lang=js"
export * from "./Badge18.vue?vue&type=script&lang=js"
import style0 from "./Badge18.vue?vue&type=style&index=0&id=ff84e37a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff84e37a",
  null
  
)

export default component.exports